import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { obterArquivoPoliticaPrivacidade, obterArquivoPoliticaPrivacidadeSuccess, obterArquivoPoliticaPrivacidadeFailure, obterArquivoPoliticaPrivacidadeFinish } from "../../actions/Sobre/obter-politica-privacidade.action";

export interface ObterArquivoPoliticaPrivacidadeState {
    response: EstruturaRetornoDadosOutputDto<string> | null;
    error: string[] | null;
}

export const initialState: ObterArquivoPoliticaPrivacidadeState = {
    response: null,
    error: null,
};

export const ObterArquivoPoliticaPrivacidadeReducer = createReducer(
    initialState,
    on(obterArquivoPoliticaPrivacidade, state => ({ ...state, error: null })),
    on(obterArquivoPoliticaPrivacidadeSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(obterArquivoPoliticaPrivacidadeFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(obterArquivoPoliticaPrivacidadeFinish, state => ({ ...state, response: null, error: null }))
);